import Dialog from '@/components/ui/Dialog';
import { PRIMARY_BTN, PRIMARY_BG } from '../shared/mentorship.constants';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export default function MentorThankfulDialog({ isOpen, onClose }: Props) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Баярлалаа"
      maxWidth="lg"
    >
      <div className="flex flex-col gap-4 items-center text-center px-2 pb-1">
        <p className="text-sm text-[#414651] leading-relaxed">
          Таны бүртгэл амжилттай хүлээн авлаа. Хөтөлбөрийн баг тантай удахгүй
          холбогдох болно.
        </p>
        <button
          type="button"
          onClick={onClose}
          className={PRIMARY_BTN}
          style={{ background: PRIMARY_BG }}
        >
          Хаах
        </button>
      </div>
    </Dialog>
  );
}
